import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GlobalService } from 'src/app/shared/services/global.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private _global: GlobalService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const token = this._global.user?.accessToken;
    if (!token) {
      return next.handle(req);
    }

    let headers = req.headers.set('Authorization', 'Bearer ' + token);

    // The review-status and report APIs are secured separately from the
    // standard dashboard endpoints. They require the tenant secret in
    // addition to the bearer token; without it the API returns a 400 and the
    // KPI falls back to zero reviewed users.
    if (req.url.includes('/company-users-review-status') || req.url.includes('/generate-user-review-report')) {
      const secretKey = this._global.user?.secretKey;
      if (secretKey) {
        headers = headers.set('YOUATTEST', secretKey);
      }
    }

    return next.handle(
      req.clone({
        headers,
      })
    );
  }
}
